import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';
import { RecentEntitiesSidebar } from '@/modules/recents/RecentEntitiesSidebar/RecentEntitiesSidebar';
import { ROUTE_KEYS } from '@/navigation/constants';
import { useRouteKeyMatch } from '@/navigation/useRouteKeyMatch';

export function GlobalSidebar() {
  const isOnHouseholdList = useRouteKeyMatch(ROUTE_KEYS.HOUSEHOLDS_LIST);
  const canEditHouseholds = useCanEditHouseholdData();

  if (isOnHouseholdList && canEditHouseholds) {
    return (
      <RecentEntitiesSidebar
        showRecentClients
        data-testid="global-sidebar-recents"
      />
    );
  }

  return null;
}
